
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { StudentList } from '@/components/admin/StudentList';
import { useStudentList } from '@/hooks/useStudentList';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

const AdminStudentListPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    students,
    isLoading,
    currentPage,
    totalPages,
    searchQuery,
    sortField,
    sortOrder,
    handleSearch,
    handlePageChange,
    handleSort,
  } = useStudentList({ limit: 10 });

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold">รายชื่อนักเรียนทั้งหมด</h1>
              <Button onClick={() => navigate('/admin/students/add')} className="flex items-center gap-2">
                <Plus className="h-4 w-4" />
                เพิ่มนักเรียน
              </Button>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <StudentList
                students={students}
                isLoading={isLoading}
                currentPage={currentPage}
                totalPages={totalPages}
                searchQuery={searchQuery}
                sortField={sortField}
                sortOrder={sortOrder}
                onSearch={handleSearch}
                onPageChange={handlePageChange}
                onSort={handleSort}
              />
            </div>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminStudentListPage;
